<template>
<v-layout justify-center>
  <v-card>
    <!--タイトル-->
      <v-card-title class="head title-center">
        {{ title }}
        <!--タイトル横アイコン-->
        <v-icon color="black" class="ml-2 mt-1">{{ icon }}</v-icon>
    </v-card-title>
    <News></News>
  </v-card>
  </v-layout>
</template>

<style>
.title-center{
  justify-content: center;
}
</style>

<script>
import News from './News'
// import News from './News.vue'

export default {
  data () {
    return {
      // タイトル
      title: 'お知らせ一覧',
      // タイトル横のアイコン
      icon: 'mdi-information'
    }
  },
  components: {
    News
  }
}
</script>
